import { Card, Table } from "antd";
import React, { useEffect } from "react";
import Filterbox from "../../ui/FilterBox/Filterbox";
import SapaHeader from "../../ui/Header/Header";
import { eventVendorsColumn } from "../../DummyAPI/TableData/Columns";
import ProgressLoader from "../../components/Loader/ProgressLoader";
import { useDispatch, useSelector } from "react-redux";
import { selectEventVendorsData, selectEventVendorsLoading } from '../../redux/selectors/eventVendorSelectors';
import { listEventVendors } from '../../redux/actions/eventVendor';
import { formatDate } from "../../utils/utils";

const EventVendors = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectEventVendorsLoading);
  const eventList = useSelector(selectEventVendorsData);

  const tableStyle = {
    tableLayout: "fixed",
  };

  // adding classname to odd table rows
  const rowClassName = (record, index) => {
    return index % 2 === 1 ? "odd-row" : "";
  };

  
  useEffect(() => {
    dispatch(listEventVendors());
  }, [dispatch]);

  const prepareDataToExport = () => {
    let data = eventList.map(item => {
      return {
        "Event Name": item?.name,
        "Description": item?.description,
        "Date": formatDate(item?.created_at)
      };
    });

    return data;
  };


  return (
    <ProgressLoader isLoading={isLoading}>
      <div className="events">
        <SapaHeader page={"Vendors"} />
        <Card className="events__container">
          <Filterbox 
            displayFilter={"none"}
            searchIsLoading={isLoading}
            searchAction={listEventVendors}
            showExportButton={false}
            showAddEventDrawer={true}
          />
          <Table
            dataSource={eventList}
            columns={eventVendorsColumn}
            pagination={false}
            rowClassName={rowClassName}
            style={tableStyle}
            scroll={{ x: 'max-content' }}
          />
        </Card>
      </div>
    </ProgressLoader>
  );
};

export default EventVendors;